export const locale = {
  lang: "it",
  data: {
    MENU: {
      INVOICES_TO_GENERATE: "Fatture da generare",
      INVOICES_TO_SEND: "Fatture da inviare",
      INVOICES_SENDED: "Fatture inviate",
      INVOICES_COMPLETED: "Fatture emesse",
      INVOICES_EXPIRED: "Fatture scadute",
      INVOICES_CASHED: "Fatture incassate",
      CREDIT_NOTE: "Note di credito",
      ROW_TYPE: "Tipo riga fattura",
      DOCUMENTS_TYPES: "Tipi documenti fatture di vendita",
      DOCUMENTS_CODES: "Codici documento fatture di vendita",
      PAYMENTS_TYPES: "Tipi di pagamento",
      SERVICE_INVOICE: "Servizi fattura",
      INVOICES_ARCHIVED: "Fatture archiviate"
    },
    ALERT: {
      YOU_CAN_AGGREGATE_ONLY_POTATOES_WITH_POTATOES: "Puoi aggregare solo righe dello stesso tipo (prodotti con prodotti e dipendenti con dipendenti).",
      CONFIRM_DELETE_INVOICE: "Sei sicuro di voler eliminare la fattura con numero ordine ORDER_NUMBER?",
      ERROR_DELETE_INVOICE: "Errore nell'eliminazione della fattura",
      SUCCESS_DELETE_INVOICE: "Fattura eliminata con successo.",
      SUCCESS_ADD_ROW_TYPE: "Tipo riga fattura aggiunto con successo.",
      ERROR_ADD_ROW_TYPE: "Errore durante l'aggiunta del tipo riga fattura.",
      SUCCESS_EDIT_ROW_TYPE: "Tipo riga fattura modificato con successo.",
      ERROR_EDIT_ROW_TYPE: "Errore durante la modifica del tipo riga fattura.",
      SUCCESS_DELETE_ROW_TYPE: "Tipo riga fattura eliminato con successo.",
      ERROR_DELETE_ROW_TYPE: "Errore durante l'eliminazione del tipo riga fattura.",
      SUCCESS_ADD_DOCUMENT_TYPE: "Tipo documento fattura di vendita aggiunto con successo.",
      ERROR_ADD_DOCUMENT_TYPE: "Errore durante l'aggiunta del tipo documento fattura di vendita.",
      SUCCESS_EDIT_DOCUMENT_TYPE: "Tipo documento fattura di vendita modificato con successo.",
      ERROR_EDIT_DOCUMENT_TYPE: "Errore durante la modifica del tipo documento fattura di vendita.",
      SUCCESS_DELETE_DOCUMENT_TYPE: "Tipo documento fattura di vendita eliminato con successo.",
      ERROR_DELETE_DOCUMENT_TYPE: "Errore durante l'eliminazione del tipo documento fattura di vendita.",
      SUCCESS_ADD_DOCUMENT_CODE: "Codice documento fattura di vendita aggiunto con successo.",
      ERROR_ADD_DOCUMENT_CODE: "Errore durante l'aggiunta del codice documento fattura di vendita.",
      SUCCESS_EDIT_DOCUMENT_CODE: "Codice documento fattura di vendita modificato con successo.",
      ERROR_EDIT_DOCUMENT_CODE: "Errore durante la modifica del codice documento fattura di vendita.",
      SUCCESS_DELETE_DOCUMENT_CODE: "Codice documento fattura di vendita eliminato con successo.",
      ERROR_DELETE_DOCUMENT_CODE: "Errore durante l'eliminazione del codice documento fattura di vendita.",
      SUCCESS_ADD_PAYMENT_TYPE: "Tipo di pagamento aggiunto con successo.",
      ERROR_ADD_PAYMENT_TYPE: "Errore durante l'aggiunta del tipo di pagamento.",
      SUCCESS_EDIT_PAYMENT_TYPE: "Tipo di pagamento modificato con successo.",
      ERROR_EDIT_PAYMENT_TYPE: "Errore durante la modifica del tipo di pagamento.",
      SUCCESS_DELETE_PAYMENT_TYPE: "Tipo di pagamento eliminato con successo.",
      ERROR_DELETE_PAYMENT_TYPE: "Errore durante l'eliminazione del tipo di pagamento.",
      ERROR_INSERT_INVOICE: "Errore durante l'inserimento della fattura.",
      SUCCESS_INSERT_INVOICE: "Fattura inserita con successo.",
      ERROR_INSERT_CREDIT_NOTE: "Errore durante l'inserimento della nota di credito.",
      SUCCESS_INSERT_CREDIT_NOTE: "Nota di credito inserita con successo.",
      ERROR_UPLOAD_ATTACHMENT: "Errore durante il caricamento dell'allegato.",
      CONFIRMATION_SET_AS_PAYED: "Stai impostando la fattura",
      INVOICES_SENT_SUCCESSFULLY_TO_ESOLVER: "Fatture inviate con successo a eSolver",
      INVOICES_SENT_SUCCESSFULLY: "Fatture inviate con successo",
      ERROR_SENDING_INVOICES: "Errore durante l'invio delle fatture",
      ERROR_SENDING_INVOICES_TO_ESOLVER: "Errore durante l'invio delle fatture a eSolver",
      ERROR_DELETE_INVOICE_ATTACHMENT: "Errore durante l'eliminazione dell'allegato",
      SUCCESS_DELETE_INVOICE_ATTACHMENT: "Allegato eliminato con successo",
      SUCCESS_UPDATE_INVOICE: "Fattura modificata con successo",
      ERROR_UPDATE_INVOICE: "Errore durante la modifica della fattura",
      ADD_NEW_SERVICE: "Aggiungi nuovo servizio",
      EDIT_SERVICE: "Modifica servizio",
      SUCCESS_ADD_INVOICE_SERVICE: "Servizio fattura aggiunto con successo.",
      ERROR_ADD_INVOICE_SERVICE: "Errore durante l'aggiunta del servizio fattura.",
      SUCCESS_EDIT_INVOICE_SERVICE: "Servizio fattura modificato con successo.",
      ERROR_EDIT_INVOICE_SERVICE: "Errore durante la modifica del servizio fattura.",
      SUCCESS_DELETE_INVOICE_SERVICE: "Servizio fattura eliminato con successo.",
      ERROR_DELETE_INVOICE_SERVICE: "Errore durante l'eliminazione del servizio fattura.",
      INVOICE_NOT_FOUND: "Fattura non trovata",
      THIS_CLIENT_HAVENT_ORDERS: "Questo cliente non ha ordini",
      CONFIRM_ARCHIVE_INVOICE: "Sei sicuro di voler archiviare la fattura della commessa \"COMMISSION_NAME\"?",
      ARCHIVE: "Archivia",
      MISSING_INVOICE_AMOUNT: "L'importo totale della fattura è inferiore di [AMOUNT]€ rispetto alle aspettative. Li userai per una prossima fattura? In caso affermativo il sistema ti farà generare un'altra fattura con questo importo presunto, altrimenti non sarà più possibile fatturarli su questo ordine se non con una fattura bianca.",
      ERROR_ARCHIVE_INVOICE: "Errore nell'archiviazione della fattura.",
      SUCCESS_ARCHIVE_INVOICE: "Fattura archiviata correttamente.",
      CONFIRM_UNARCHIVE_INVOICE: "Sei sicuro di voler ripristinare la fattura della commessa \"COMMISSION_NAME\"?",
      ERROR_UNARCHIVE_INVOICE: "Errore nel ripristino della fattura.",
      SUCCESS_UNARCHIVE_INVOICE: "Fattura ripristinata correttamente.",
      RESTORE: "Ripristina",
      ERROR_LOADING_INVOICES_TO_GENERATE: "Errore nel caricamento delle fatture da generare.",
      ERROR_LOADING_INVOICES_ARCHIVED: "Errore nel caricamento delle fatture archiviate.",
      "Order not found": "Ordine non trovato",
      INVOICES_LINES_DISCONNECTED_FROM_ANALYTICS: "Per prevenire errori tutte le righe della fattura sono state scollegate al loro dettaglio economico.",
      INVOICES_LINES_ORDER_RESET: "Per prevenire errori in tutte le righe della fattura è stato svuotato il campo \"Ordine\".",
      ERROR_SYNC_CASHED_INVOICE: "Errore nella sincronizzazione delle fatture incassate.",
      SUCCESS_SYNC_CASHED_INVOICE: "Sincronizzazione delle fatture incassate effettuata con successo.",
      INVOICE_STATUS_UPDATE_ERROR: "Errore nell'aggiornamento dello stato della fattura."
    },
    ERRORS: {
      FIELD_IS_REQUIRED: "Campo obbligatorio",
      INSERT_USE_LIST: "Il campo utilizza lista è obbligatorio"
    },
    GENERATE_INVOICE: "Genera fattura",
    COMMISSION_DETAILS: "Dettagli commessa",
    ROW_TYPE: "Tipo di riga",
    SERVICE_TRACK: "Codice articolo/Voce doc./Voce cespite/Servizio",
    SERVICE_DESCRIPTION: "Descrizione articolo/contropartita/fattura comm.",
    CIG_CODE: "CIG",
    CUP_CODE: "CUP",
    ACCRUAL_DATE_FROM: "Periodo competenza da (Contabile)",
    ACCRUAL_DATE_TO: "Periodo competenza a (Contabile)",
    YEAR_EXERCISE: "Esercizio competenza (Contabile)",
    EXPIRATION_DATE: "Data scadenza",
    DOCUMENT_DATE: "Data documento",
    INVOICE_ROWS: "Righe fattura",
    CREDIT_NOTE_ROWS: "Righe nota di credito",
    DISCOUNT: "Sconto",
    ADD_NEW_ROW_TYPE: "Aggiungi nuovo tipo riga",
    EDIT_ROW_TYPE: "Modifica tipo riga",
    ADD_NEW_DOCUMENT_TYPE: "Aggiungi nuovo tipo documento",
    EDIT_DOCUMENT_TYPE: "Modifica tipo documento",
    ADD_NEW_DOCUMENT_CODE: "Aggiungi nuovo codice documento",
    EDIT_DOCUMENT_CODE: "Modifica codice documento",
    ADD_NEW_PAYMENT_TYPE: "Aggiungi nuovo tipo di pagamento",
    EDIT_PAYMENT_TYPE: "Modifica tipo di pagamento",
    DELETE_ROW: "Elimina riga",
    ADD_ROW: "Aggiungi riga",
    NEW_ROW: "Nuova riga",
    UNITARY_PRICE: "Prezzo unitario",
    INVOICE_DOCUMENT_TYPE: "Tipo documento fatture di vendita",
    INVOICE_DOCUMENT_CODE: "Codice documento fatture di vendita",
    VAT_CODE: "Codice IVA",
    NOT_PROCESSED: "Non processato",
    PROCESSING: "In lavorazione",
    PROCESSED: "Processato",
    FAILED: "In errore",
    INVOICE_DOCUMENTS: "Documenti fatture di vendita",
    SUCCESS: "Completato",
    YOU_ARE_SENDING: "Stai inviando",
    INVOICES_TO: "fattura/e in",
    INVOICES_TO_SENDED: "fattura a inviata",
    INVOICES_TO_SENDED_PLURAL: "fatture a inviate",
    YOU_ARE_SETTING: "Stai spostando",
    AS_SENDED: "come inviate",
    SET_AS_SENDED: "Imposta come emesse",
    USE_LIST: "Utilizza lista",
    GROUPED_ROWS: "Righe raggruppate",
    MERGE_INTO_A_LINE: "Raggruppa in una riga",
    HAS_CLIENT_APPROVAL: "Ricevuta approvazione del cliente",
    NEED_CLIENT_APPROVAL: "Richiede approvazione del cliente",
    NEED_WORKDAYREPORT_COMPLETED: "Uno o più dipendenti devono inviare il rapportino",
    DETACHMENT_TIME_MATERIAL: "Time Material - Distacco",
    DETACHMENT_TASK: "Task - Distacco",
    STATE_INVOICE: "Stato fattura",
    SET_INVOICE_AS_CASHED: "Imposta fattura come incassata",
    MIN_NUMBER: "Numero minimo",
    MAX_NUMBER: "Numero massimo",
    EDIT_INVOICE: "Modifica fattura",
    NEED_ORDER_NUMBER: "Manca il numero d'ordine",
    SEARCH_COMMISSION_NAME: "Cerca per nome commessa",
    STORAGE_UNIT_MEASURE: "Unità di misura",
    CODE_PURCHASES: "Codice conto acquisti",
    PURCHASES_VAT: "Codice iva acquisti",
    SALES_ACCOUNT_CODE: "Codice conto vendite",
    SALES_VAT: "Codice iva vendite",
    INVOICE_DETAIL: "Dettaglio fattura",
    HEAD_OFFICE_DATA: "Dettaglio indirizzo di fatturazione (sede legale)",
    INVOICE_DOCUMENT_INFORMATIONS: "Informazioni documento fattura",
    CURRENCY: "Valuta",
    CAUSAL: "Causale",
    CLIENT_ORDER_DETAIL: "Dettaglio ordine cliente",
    NOT_PROVIDED: "Non pervenuto",
    CASHED: "Incassata",
    GENERAL_INFORMATION: "Informazioni generali",
    LAST_STATUS_UPDATED: "Ultimo aggiornamento di stato",
    PAYMENT_DETAIL: "Dettagli pagamento",
    NOT_CASHED: "Da incassare",
    YEAR_OF_ISSUE: "Anno di fatturazione",
    MONTH_OF_ISSUE: "Mese di fatturazione",
    IS_CREDIT_NOTE: "È una nota di credito",
    CREATE_CREDIT_NOTE: "Genera nota di credito",
    SPLIT_ROWS_FOR_EDIT_ECONOMICS_DATA: "Separa le righe (elimina la riga raggruppata) per modificare l'importo della riga raggruppata.",
    DELTA_TIME_MATERIAL: "Time Material - Delta",
    DELTA_TASK: "Task - Delta",
    INVOICE_ORDER_NUMBER: "Numero d'ordine in fattura",
    DELTA: "Delta",
    TOTAL_INVOICES: "Totale fatture",
    SUM_ESTIMATED_REVENUE: "Totale fatturato presunto",
    ARCHIVE: "Archivia",
    RESTORE: "Ripristina",
    REMOVE_ROWS: "Rimuovi righe",
    SELECT_ALL_TO_DELETE: "Seleziona tutte le righe",
    DESELECT_ALL_TO_DELETE: "Deseleziona tutte le righe",
    BALANCE: "Bilancio",
    LAST_MONTH_TREND: "Andamento dell'ultimo mese",
    INVOICES_BALANCE_DIVIDED_BY_MONTHS: "Bilancio del fatturato diviso per mese.",
    RESOURCE_TYPE: "Tipo risorsa",
    INVOICE_GENERAL_INFO: "Dati generali",
    DOCUMENT_CODE: "Codice documento",
    SYNC_INVOICES: "Sincronizza fatture",
    SYNC_PAYED_INVOICES: "Sincronizza incassi",
    STATUS_NOTE: "Note stato",
    INVOICES_SYNC_WITH_ERROR: "Errore nella sincronizzazione delle fatture.",
    INVOICES_SYNC_NOT_FOUND: "Durante la sincronizzazione alcune fatture non sono state trovate sui sistemi eSolver.",
    INVOICES_WITH_THESE_IDS_ARE_IN_ERROR: "Le fatture con questi id hanno ricevuto errore",
    INVOICES_NOT_FOUND: "Fatture non trovate",
    SELECT_CLIENT_THEN_INVOICE_TO_LOAD_ROWS: "Per visualizzare le righe seleziona prima un cliente ed una fattura.",
    YEAR_OF_ISSUE_FOR_CREDIT_NOTE: "Anno di emissione della fattura da collegare",
    EDIT_CREDIT_NOTE: "Modifica nota di credito",
    WAITING: "Da inviare",
    INVOICES_SYNC_DUPLICATED: "Durante la sincronizzazione alcune fatture sono state trovate più di una volta sui sistemi eSolver.",
    INVOICES_DUPLICATED: "Fatture duplicate",
    CANCEL_SENDING: "Annulla invio",
  }
};
